import styled from 'styled-components';
import DropdownItem from './DropdownItem';

const DropdownList = ({ data }) => {
  return (
    <ListWr>
      {data.map((item, index) => {
        return (
          <DropdownItem dropdown={item.Drop_Down} data={item} key={`${index}-dropdown-item`} />
        );
      })}
    </ListWr>
  );
};

const ListWr = styled.ul``;

export default DropdownList;
